import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { memo, useContext } from 'react';
import { areSetsEqual } from '../../../utils/are-sets-equal';
import { SeatPickerScreenPosition } from '../types/config/screen-position';
import { SeatPickerContextInstance } from '../types/context';
import { SeatPickerSeat } from './seat';
const b = bemClassBuilder('seat-picker-row');
export const SeatPickerRow = memo(props => {
    const { row, area, scaleFactor, isSelectable, seatAvailabilityMap, selectedSeatIds, friendSeatIds } = props;
    const { config } = useContext(SeatPickerContextInstance);
    const seats = config.screen.position === SeatPickerScreenPosition.Bottom ? row.seats : row.seats.slice().reverse(); // Reversed so that the tab order of seats goes top-left to bottom-right
    return (_jsx("g", Object.assign({ className: b.block() }, { children: seats.map(seat => (_jsx(SeatPickerSeat, { area: area, scaleFactor: scaleFactor, seat: seat, availabilityStatus: seatAvailabilityMap[seat.id] || config.seats.defaultAvailabilityStatus, isSelected: selectedSeatIds.has(seat.id), isSelectable: isSelectable, isFriend: friendSeatIds.has(seat.id) }, seat.id))) })));
}, (newProps, oldProps) => {
    // Manually compare the props so that we can check if the new and old seatId sets have changed.
    const areSelectedSeatIdsSame = areSetsEqual(newProps.selectedSeatIds, oldProps.selectedSeatIds);
    const areFriendSeatIdsSame = areSetsEqual(newProps.friendSeatIds, oldProps.friendSeatIds);
    return (areSelectedSeatIdsSame &&
        areFriendSeatIdsSame &&
        newProps.row === oldProps.row &&
        newProps.area === oldProps.area &&
        newProps.seatAvailabilityMap === oldProps.seatAvailabilityMap &&
        newProps.scaleFactor === oldProps.scaleFactor &&
        newProps.isSelectable === oldProps.isSelectable);
});
SeatPickerRow.displayName = 'SeatPickerRow';
